module.exports = __webpack_public_path__ + "img/bird_1.046d401c.jpg";